import React from 'react';
import { Body1 } from '@ui';
import { EmailSignUp } from '@containers/authentication/EmailSignUp';
import styled from 'styled-components';
import { selectLightTheme } from '@utils/themes';
import { CityScape } from '@assets/svg/CityScape';
import useWindowSize from '@hooks/application/useWindowSize';
import { SplashSectionWrapper } from './styles';

const yellow = '#fcff7d';
const skylineColor = '#777';
const textOverlay = yellow;
const headingTextColor = '#222';
const forceColorText = '#222';

const H1 = styled.h1`
  text-transform: uppercase;
`;
const HeadingWrapper = styled.div`
  text-transform: uppercase;
  max-width: 900px;

  h1 {
    display: inline;
    color: ${headingTextColor} !important;
  }
`;
const Wrapper = styled.div`
  position: relative;
  z-index: 2;

  height: calc(100vh - 54px);
  max-height: 1400px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  * {
    color: ${({ theme }) => selectLightTheme(theme).text};
  }
`;
const EmailSignUpWrapper = styled.div`
  padding-top: 36px;
  max-width: 460px;
`;
const DescriptionWrapper = styled.div`
  padding-top: 28px;
  padding-right: 8px;

  max-width: ${({ width }) => (isNaN(width) ? '100%' : width + 'px')};

  * {
    color: ${headingTextColor} !important;
  }
`;
const ForceColorWrapper = styled.span`
  color: ${forceColorText};
`;

const PositionWrapper = styled.div`
  position: relative;
  z-index: 2;
`;
const ImageWrapper = styled.div`
  position: absolute;
  top: ${({ Top }) => Top + 'px'};
  height: 100vh;
  width: 100vw;

  svg {
    height: 800px !important;
    width: auto !important;
  }

  path {
    // fill: ${({ theme }) => theme.colorPalette.primary.oak} !important;
    fill: ${({ theme }) => skylineColor} !important;
  }

  z-index: 1;
  pointer-events: none;
  overflow: hidden;
`;
const FirstImage = styled.div`
  position: absolute;
  z-index: 1;
`;
const SecondImage = styled.div`
  position: absolute;
  z-index: 1;
  left: 812px;
`;
const ThirdImage = styled.div`
  position: absolute;
  z-index: 1;
  left: 1624px;
`;
const ForthImage = styled.div`
  position: absolute;
  z-index: 1;
  left: 2436px;
`;
const JumbotronTextPosition = styled.div`
  position: relative;
  z-index: 2;
`;
const JumbotronTextWrapper = styled.div`
  padding: 24px;
  position: relative;
  z-index: 2;
`;
const JumbotronTextBackground = styled.div`
  background: ${() => textOverlay};
  opacity: 0.85;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 6px;
  z-index: 1;
`;

const calcTop = (windowHeight) => {
  const imageHeight = 800;
  const value = (windowHeight - imageHeight) / 2;
  return value - value * 0.15;
};

const BackgroundImage = () => {
  const { height: windowHeight, width: windowWidth } = useWindowSize();
  return (
    <ImageWrapper Top={calcTop(windowHeight)}>
      <FirstImage>
        <CityScape />
      </FirstImage>
      <SecondImage>
        <CityScape />
      </SecondImage>
      {windowWidth > 1600 && (
        <ThirdImage>
          <CityScape />
        </ThirdImage>
      )}
      {windowWidth > 2000 && (
        <ForthImage>
          <CityScape />
        </ForthImage>
      )}
    </ImageWrapper>
  );
};

function DescriptionSizer({ children, headerRef }) {
  const [width, setWidth] = React.useState(null);

  React.useEffect(() => {
    window.elRef = headerRef?.current;
    const handleResize = () => {
      const elWidth = headerRef?.current?.offsetWidth;

      if (!isNaN(elWidth)) {
        if (elWidth !== width) {
          setWidth(elWidth);
        }
      }
    };
    window.addEventListener('resize', handleResize, true);

    const elWidth = headerRef?.current?.offsetWidth;
    if (!isNaN(elWidth)) {
      handleResize();
    }

    return () => window.removeEventListener('resize', handleResize, true);
  }, [headerRef, width]);

  return <DescriptionWrapper width={width}>{children}</DescriptionWrapper>;
}

const ForceColor = ({ children }) => {
  return <ForceColorWrapper>{children}</ForceColorWrapper>;
};

export const Jumbotron = () => {
  const headerRef = React.useRef(null);

  return (
    <PositionWrapper>
      <BackgroundImage />
      <SplashSectionWrapper className={'jumbotron'}>
        <Wrapper>
          <JumbotronTextPosition>
            <JumbotronTextBackground />
            <JumbotronTextWrapper>
              <HeadingWrapper>
                <H1 ref={headerRef}>
                  <ForceColor>Human</ForceColor> quality financial analysis, <ForceColor>10x&nbsp;faster</ForceColor>
                </H1>
              </HeadingWrapper>
              <DescriptionSizer headerRef={headerRef}>
                <Body1>
                  Reliably scale human-level analyses on your own research, public filings, and other datasets to
                  generate elite alpha and deal flow.
                </Body1>
              </DescriptionSizer>
              <EmailSignUpWrapper>
                <EmailSignUp />
              </EmailSignUpWrapper>
            </JumbotronTextWrapper>
          </JumbotronTextPosition>
        </Wrapper>
      </SplashSectionWrapper>
    </PositionWrapper>
  );
};
